angular.module('app.controllers').controller 'ProgramsCtrl', [
  '$scope', 'APIPrograms', 'APIRead2', '$timeout', '$cookies', '$rootScope', 'Table', 'APIRead2Table', '$http'
].append (self, APIPrograms, APIRead2, $timeout, $cookies, root, Table, APIRead2Table, $http) ->


  APIRead2.query {entry_type: 'presenter', type: 'full', nogroup: true}, (data) ->
    self.data1 = data
  , (response) ->
    UI.notify false, response.error.data

  self.eventDays = [
    {
      day: 1
      field: 'event_day1'
      full: '02.10.2024'
      short: '02.10.'
    }
    {
      day: 2
      field: 'event_day2'
      full: '03.10.2024'
      short: '03.10.'
    }
    {
      day: 3
      field: 'event_day3'
      full: '04.10.2024'
      short: '04.10.'
    }
    {
      day: 4
      field: 'event_day4'
      full: '05.10.2024'
      short: '05.10.'
    }
  ]

  self.days = ['01', '02.10.2024', '03.10.2024', '04.10.2024', '05.10.2024']
  self.day = parseInt(self.get('day')) || null
  mday = moment().format('DD.MM.YYYY')
  if !self.day? || self.day not in [1..4]
    self.day = if mday in self.days then self.days.indexOf(mday) else 1

  self.setDay = (day) ->
    return if self.day == day
    self.day = day

  self.isDay = (day) ->
    return self.day == day

  self.track = 1000

  self.setTrack = (track_id) ->
    return if self.track == track_id || !self.programs?.$resolved
    self.track = track_id

  self.isTrack = (track_id) ->
    return self.track == track_id

  #
  # Location functionality
  #
  
  self.locationSelected = false

  self.$watch 'tempParams.location.point', (newObj, oldObj) ->
    return self.tempParams.location.address = "" unless newObj?.length > 0
    self.preview.params.location = newObj.filter(Boolean).join("|")    
  , true

  self.getLocationDetail = (prediction = null, coords = null, callback = false) ->
    geocoder = new google.maps.Geocoder()

    params = {}

    if prediction?
      params.placeId = prediction.place_id
    else
      params.latLng = new google.maps.LatLng(coords)

    geocoder.geocode(params, (results, status) ->
      if (status == google.maps.GeocoderStatus.OK) 
        
        results = results.filter((res) -> return "locality" in res.types || "political" in res.types)

        if (results[0])
          self.tempParams.location =
            point: [results[0].geometry.location.lat(), results[0].geometry.location.lng()]
            address: if prediction? then prediction.description else results[0].formatted_address

          # clear predictions list if user click on "get my location"
          self.predictions = null unless prediction?
          # location geocoded 
          self.isLocChanged = false

          self.$applyAsync()
        else 
          self.tempParams.location =
            point: []
            address: ""
          UI.notify false, 'No results found'            
      else
        self.tempParams.location =
          point: []
          address: ""
        UI.notify false, 'Geocoder failed due to: ' + status      
    )

  self.getCurrentLocation = (api = false) ->
    if (navigator.geolocation && !api)
      navigator.geolocation.getCurrentPosition((position) ->
        #self.tempParams.location.point = [position.coords.latitude, position.coords.longitude]
        self.getLocationDetail(null, {lat: position.coords.latitude, lng: position.coords.longitude})
      , (response) ->
        self.getCurrentLocation(true)        
      )
    else
      url = "https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyBwYHHt1Uxa-K46nWa3PdAWtG444TmN_9k";
      $http.post(url, {}).then((response) ->
        #self.tempParams.location.point = [response.data.location.lat, response.data.location.lng]
        self.getLocationDetail(null, {lat: response.data.location.lat, lng: response.data.location.lng})
      , (response) ->
        UI.notify false, response.data.error.message
      )

  self.setPredictionLocation = (prediction) ->
    self.getLocationDetail(prediction)

  self.isLocChanged = false
  self.locationChanged = () ->
    return unless self.tempParams.location.address.length > 3
    self.isLocChanged = true
    service = new google.maps.places.AutocompleteService()
    service.getPlacePredictions({input: self.tempParams.location.address, types: ['locality']}, (predictions, status) ->
      if (status != google.maps.places.PlacesServiceStatus.OK || !predictions)
        UI.notify false, status
        return

      self.predictions = predictions
      self.dropdownLO?.show()
      self.$apply()
    )

  self.searchKey = ($event, dropdown) ->
    if $event.keyCode == 13
      self.applyFilter()
      self.dropdownSE.hide() if dropdown is "dropdownSE"
    else
      self.dropdownSE.show() if dropdown is "dropdownSE"

  dropdownSearch = document.getElementById('searchDropdown')
  if dropdownSearch
    self.dropdownSE = bootstrap.Dropdown.getOrCreateInstance(dropdownSearch)

  dropdownLocation = document.getElementById('locationDropdown')
  if dropdownLocation
    self.dropdownLO = bootstrap.Dropdown.getOrCreateInstance(dropdownLocation)

    dropdownLocation.addEventListener('hide.bs.dropdown', (event) ->
      self.$applyAsync()
    )

  tableName   = 'jub.e.' + (root.user?.shortcode || 'test')
  cookiesName = 't.' + tableName

  defaultParams = 
    og: ""
    se: ""
    co: ""
    ap: ""
    tp: ""
    tm: ""
    search: ""
    location: ""
    distance: 5

  tempParams = $cookies.getObject(cookiesName) || defaultParams

  (self.clearParams = (source) ->
    loc = source.location?.split("|").filter(Boolean).map(Number) || []
    self.tempParams =
      og: source.og?.split("|").filter(Boolean).map(Number) || []
      se: source.se?.split("|").filter(Boolean).map(Number) || []
      co: source.co?.split("|").filter(Boolean).map(Number) || []
      ap: source.ap?.split("|").filter(Boolean).map(Number) || []
      tp: source.tp?.split("|").filter(Boolean) || []
      tm: source.tm?.split("|").filter(Boolean).map(Number) || []
      da: source.da || self.day
      search: source.search
      location: 
        point: loc
        address: ""
      distance: String(source.distance || 5)

    self.getLocationDetail(null, {lat: loc[0], lng: loc[1]}) if loc.length > 0

  )(tempParams)

  self.paramsToQuery = () ->
    return
      og: self.tempParams.og?.join("|") || ""
      se: self.tempParams.se?.join("|") || ""
      co: self.tempParams.co?.join("|") || ""
      ap: self.tempParams.ap?.join("|") || ""
      tp: self.tempParams.tp?.join("|") || ""
      tm: self.tempParams.tm?.join("|") || ""
      da: self.tempParams.da || 1
      search: self.tempParams.search
      location: self.tempParams.location?.point.join("|") || ""
      distance: self.tempParams.distance

  self.data = Table
    name: tableName
    type: "partial"
    resource: APIRead2Table
    params:
      entry_type: 'program_highlights'
      da: self.day
      limit: 12
  
  self.filterCount = 0
  self.$watch 'data.params', (newObj, oldObj) ->
    self.page = 1
    self.filterCount = self.tempParams.tp.length + self.tempParams.og.length + self.tempParams.se.length + self.tempParams.co.length + self.tempParams.ap.length
    self.preview.params.da = newObj.da if newObj.da != oldObj.da    
  , true

  previewParams = angular.copy(tempParams)
  previewParams.page = 1
  previewParams.da = self.data.params.da
  previewParams.entry_type = 'program_highlights'

  self.preview = Table
    name: "#{tableName}.temp"
    type: "partial"
    resource: APIRead2Table
    cookies: false
    params: previewParams

  self.$watch 'preview.params.search', (newObj, oldObj) ->
    self.sugg.params.search = newObj
  , true

  self.sugg = Table
    name: "#{tableName}.sugg"
    type: "partial"
    resource: APIRead2Table
    cookies: false
    params: 
      limit: 5
      entry_type: 'program_highlights'


  self.page = 1
  self.loadMore = () ->
    return if self.page >= self.data.data.pages
    
    self.page++ 
    
    params = angular.copy(self.data.params)
    params.page = self.page

    self.moreLoad = true
    APIRead2.query params, (data) ->
      self.more = data
      self.data.data.display = self.data.data.display.concat(self.more)
      self.moreLoad = false


  self.setDistance = (distance) ->
    return if self.preview.params.distance == distance
    self.preview.params.distance = distance

  self.filterChanged = (key) ->
    self.preview.params[key] = self.tempParams[key].filter(Boolean).join("|")
    #if key is 'tp'
    #  self.data.params[key] = self.preview.params[key]

  self.resetFilter = () ->
    self.clearParams(angular.copy(defaultParams))
    self.applyFilter(true)
  
  self.applyFilter = (reset = false) ->

    if self.isLocChanged
      self.getLocationDetail(self.prediction[0], null) if self.predictions?

    angular.extend(self.preview.params, self.paramsToQuery(self.tempParams)) if reset
    angular.extend(self.data.params, self.preview.params)


  self.saveForm = (form) ->
    self.feForm = form

  self.$on 'reloadData', (event) ->
    newParams = $cookies.getObject(cookiesName)
    self.clearParams(newParams)
    angular.extend(self.preview.params, newParams)
    angular.extend(self.data.params, newParams)

  self.activeFilter = (item, index, array) ->
    return false if item.entry_code in ['tm', 'be', 'tp']
    return item.entry_id in self.tempParams[item.entry_code]

  self.removeFilter = (item) ->
    ind = self.tempParams[item.entry_code].indexOf(item.entry_id)
    return unless ind >= 0
    self.tempParams[item.entry_code].splice(ind, 1)
    self.applyFilter(true)

  self.setTp = (entry_id) ->
    self.clearParams(defaultParams)
    self.tempParams.tp.push(entry_id)
    self.applyFilter(true)


  self.presenterQuery = APIRead2.query {entry_type: 'program_highlights', exhibitor_id: 819655}, (data) ->
    data = data.filter (program) ->
      for i in [self.day..4]
        return true if !!program["event_day#{i}"]          
      return false

    self.top = data.shift()
    self.presenter = data

  , (response) ->
    UI.notify false, response.error.data


  self.$watch 'day', (newObj, oldObj) ->
    self.loadPrograms(newObj)
    self.data.params.da = newObj
  , true

  self.loadPrograms = (day) ->
    self.programs?.$resolved = false

    APIRead2.query {entry_type: 'training_paths', with_count: true, type: 'full', count_table: 'entries', count_type: 'program_highlights', da: self.day}, (data) ->
      self.topstat = data
    , (response) ->
      UI.notify false, response.error.data

    APIPrograms.get {_entry: 'programs', day: self.day}, (data) ->
      return self.programs = data      
    , (response) ->
      UI.notify false, response.error.data


  self.slickInit = false
  self.slick =
    infinite: true
    dots: true
    arrows: true
    dotsClass: 'slider-dots mt-0'
    appendDots: '.program-page-slider-dots'
    customPaging: (slider, i) -> 
      return false if slider.slideCount == 1 || slider.slideCount <= slider.options.slidesToShow
      return "<a class='slider-dots-item'></a>"

    slidesToShow: 2
    slidesToScroll: 2
    prevArrow: '<div class="slider-control slider-control-prev"></div>'
    nextArrow: '<div class="slider-control slider-control-next"></div>'
    speed: 500
    fade: false
    autoplay: false
    autoplaySpeed: 5000
    useCSS: false
    cssEase: 'linear'
    method: {}
    event: 
      init: (event, slick) ->
        self.slickInit = true
        self.$applyAsync()

    responsive: [
      {
        breakpoint: 1200
        settings: 
          slidesToShow: 2
          slidesToScroll: 2
      }
      {
        breakpoint: 992
        settings: 
          slidesToShow: 1
          slidesToScroll: 1
          arrows: false
      }
    ]